import { Navigate, Route, Routes } from "react-router"
import { LoginComponent } from "./login/LoginComponent"

export const AuthRoutes = () => {
  return (
    <Routes>
      <Route path="" element={<Navigate to="login" replace/>} />
      <Route path="login" element={<LoginComponent />} />
    </Routes>
  )
}